import {
  anonymousElementId,
  ClickableElementIdentifiability,
  ClickableElementInteractionType,
} from "@redotech/redo-model/email-builder/clickable-elements";
import {
  ensureProtocolPresent,
  isValidLink,
  sanitizeUrl,
} from "@redotech/util/link";
import { ObjectId } from "bson";
import Link from "quill/formats/link";

export class QuillLink extends Link {
  static override create(value: string) {
    const sanitizedValue = sanitizeUrl(value);

    const link = isValidLink(sanitizedValue)
      ? ensureProtocolPresent(sanitizedValue)
      : sanitizedValue;
    const node = super.create(link);
    node.setAttribute("href", link);

    // data-link-id is used for tracking link clicks in emails.
    // A unique id is used so that even different links with the same href can be differentiated
    node.setAttribute(
      "data-link-id",
      anonymousElementId({
        idSuffix: new ObjectId().toString(),
        identifiability: ClickableElementIdentifiability.ANONYMOUS,
        interactionType: ClickableElementInteractionType.LINK,
      }),
    );

    return node;
  }
}
